"use strict";
import { __module as r } from "./index.es521.js";
import { __require as o } from "./index.es522.js";
import { __require as p } from "./index.es523.js";
var e;
function i() {
  return e ? r.exports : (e = 1, process.env.NODE_ENV === "production" ? r.exports = o() : r.exports = p(), r.exports);
}
export {
  i as __require
};
//# sourceMappingURL=index.es508.js.map
